"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePropertiesWithEmptyString = void 0;
var removePropertiesWithEmptyString = function (obj) {
    return Object.keys(obj)
        .filter(function (item) { return obj[item] !== ''; })
        .reduce(function (acc, item) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[item] = obj[item], _a)));
    }, {});
};
exports.removePropertiesWithEmptyString = removePropertiesWithEmptyString;
